export function getLatitudeLongitude(latLon: string) {
  if (!latLon) return { isValid: false, lat: undefined, lng: undefined };
  const lat = parseFloat(latLon.split(",")[0]);
  const lng = parseFloat(latLon.split(",")[1]);

  if (isNaN(lat) || isNaN(lng)) {
    return { isValid: false, lat: undefined, lng: undefined };
  }

  const isLatitude = isFinite(lat) && Math.abs(lat) <= 90;
  const isLongitude = isFinite(lng) && Math.abs(lng) <= 180;
  return { isValid: isLatitude && isLongitude, lat, lng };
}
